import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://4268416a195842569c5df7299cadf887@sentry.io/1374458',
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENV,
})

export default Sentry
